import {APISettings} from '../config.js';

export default {
  zipcodes(data) {
    return fetch('/autocomplete/location?' + new URLSearchParams({
        q: data
    }), {
        method: 'GET',
        headers: APISettings.headers,
    })
      .then(function (response) {
        if (response.status !== 200) {
          throw response.status;
        } else {
          return response.json();
        }
      })
  },
  address(address, zipcode) {
    return fetch('/autocomplete/address?' + new URLSearchParams({
        q: address,
        number: 1,
        bus: 0,
        'zipcodes[]': zipcode
    }), {
        method: 'GET',
        headers: APISettings.headers,
    })
      .then(function (response) {
        if (response.status !== 200) {
          throw response.status;
        } else {
          return response.json();
        }
      })
  },
}

